module.exports = __webpack_public_path__ + "static/media/preview_phone_12_A.557eaa8c.svg";